import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-star",
  templateUrl: "./med-icon-star.component.html",
})
export class MedIconStarComponent extends SvgMixinComponent {}
